import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'
import { PZSE_STALE_FIELD_OUTLINE_COLOR } from './mounting_systems/SnapNRack/PZSE'

const STALE_OUTLINE_BORDER = `${PZSE_STALE_FIELD_OUTLINE_COLOR} !important`

/** Styles the outlined input border (not a wrapper outline) when PZSE max-span deps are stale. */
export const useMountingStaleInputBorderStyles = makeOpenSolarStyles({
  staleInputBorder: {
    '& .MuiOutlinedInput-notchedOutline, & .OSUI-OutlinedInput-notchedOutline, & fieldset': {
      borderColor: STALE_OUTLINE_BORDER,
      borderWidth: '2px !important',
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover fieldset, & .OSUI-OutlinedInput-root:hover .OSUI-OutlinedInput-notchedOutline, & .OSUI-OutlinedInput-root:hover fieldset':
      {
        borderColor: STALE_OUTLINE_BORDER,
      },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused fieldset, & .OSUI-OutlinedInput-root.Mui-focused .OSUI-OutlinedInput-notchedOutline, & .OSUI-OutlinedInput-root.Mui-focused fieldset':
      {
        borderColor: STALE_OUTLINE_BORDER,
        borderWidth: '2px !important',
      },
  },
})
